import { render, staticRenderFns } from "./PortfolioProjectOverview.vue?vue&type=template&id=a2122d76&scoped=true&"
import script from "./PortfolioProjectOverview.vue?vue&type=script&lang=ts&"
export * from "./PortfolioProjectOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2122d76",
  null
  
)

export default component.exports